import React, { useEffect, useState } from 'react'
import {
    GlobalOutlined, HomeFilled, DatabaseFilled, ImportOutlined, ExportOutlined, ProfileOutlined, DollarCircleFilled, SettingFilled,
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    UnorderedListOutlined,
    UserOutlined,
    LogoutOutlined,
} from '@ant-design/icons';
import { isMobile } from "react-device-detect";
import { Button, Layout, Menu, theme, Flex, Avatar, Image } from 'antd';
import { useUser } from '../../hook/UserHook';
import { Link, useLocation } from "react-router-dom";
import * as PATH from '../../constant/path';
import logo from '../../../logo.png'

const { Header, Sider, Content } = Layout;
const { SubMenu } = Menu;

const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'fixed',
    insetInlineStart: 0,
    top: 60,
    bottom: 0,
    scrollbarWidth: 'thin',
    scrollbarGutter: 'stable',
};

export default function BaseCMSLayout(props) {
    const { user, logOut } = useUser()
    const [collapsed, setCollapsed] = useState(isMobile ? true : false);
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();
    const location = useLocation();
    const currentPath = location.pathname;
    // console.log("CURRENT PATH: ", currentPath)

    const onMenuClick = () => {
        console.log('onMenuClick')
        if (isMobile)
            setCollapsed(true);
        props.onMenuClick && props.onMenuClick()
    };

    const collapseMenu = () => {
        setCollapsed(!collapsed)
    }

    return (
        <Layout style={{ height: "96vh" }}>
            <Header
                style={{
                    display: 'flex',
                    // alignItems: 'center',
                    height: '60px',
                    color: 'white',
                    paddingLeft: "14px",
                    paddingRight: "20px",
                    position: 'sticky',
                    top: 0,
                    zIndex:1000
                }}
            >
                <Flex justify='space-between' style={{ width: "100%" }}>
                    <Flex justify='space-between' gap="middle">
                        <Image
                            width={50}
                            src={logo}
                        />
                        <div style={{ fontWeight: 'bold', fontSize: '12pt' }}>TEDDY MATH {isMobile ? "" : "- TRANG QUẢN TRỊ HỆ THỐNG"}</div>
                    </Flex>
                    <Flex align='center' justify='center' gap={'middle'}>
                        <div>{user?.email}</div>
                        <Avatar style={{ backgroundColor: '#87d068' }} icon={<UserOutlined />} />
                    </Flex>
                </Flex>
            </Header>
            <Layout style={{height:"95vh", overflowY: 'scroll'}}>
                <Sider style={siderStyle} trigger={null} collapsible collapsed={collapsed}
                    breakpoint="lg"
                    collapsedWidth={isMobile ? "0" : "50"}
                >
                    <div className="demo-logo-vertical" />
                    <Menu
                        theme="dark"
                        mode="inline"
                        defaultSelectedKeys={isMobile ? [] : ['1']}
                        defaultOpenKeys={isMobile ? [] : ['customer', 'config']}
                    >
                        {/* <Flex align='center' justify='center'><Image src={logo} style={{width:isMobile?"80px":(collapsed?"35px":"120px"), margin:isMobile?"1px":"10px"}}/></Flex> */}
                        <Menu.Item key="1">
                            <Link to={PATH.HOME}>
                                <HomeFilled />
                                <span>Dashboard</span>
                            </Link>
                        </Menu.Item>
                        <SubMenu key="customer" title={
                            <span> <UserOutlined /> <span>Khách hàng</span> </span>
                        }
                        >
                            <Menu.Item key="2" onClick={onMenuClick}> <Link to={PATH.CUSTOMER}>Người dùng</Link> </Menu.Item>
                            <Menu.Item key="3" onClick={onMenuClick}> <Link to={PATH.SCHOOL}>Trường học</Link> </Menu.Item>
                            <Menu.Item key="4" onClick={onMenuClick} ><Link to={PATH.IMPORT}> <ImportOutlined /><span>Import</span></Link></Menu.Item>
                            <Menu.Item key="5" onClick={onMenuClick}><Link to={PATH.EXPORT}> <ExportOutlined /><span>Export</span></Link></Menu.Item>
                            {/* <Menu.Item key="6" onClick={onMenuClick}> <Link to={PATH.CUSTOMER}>Thống kê</Link> </Menu.Item> */}
                        </SubMenu>

                        <SubMenu
                            key="config"
                            title={
                                <span>
                                    <GlobalOutlined />
                                    <span>Cấu hình Game</span>
                                </span>
                            }
                        >
                            <Menu.Item key="7" onClick={onMenuClick} ><Link to={PATH.CONFIG}> <UnorderedListOutlined /><span>Question Config</span></Link></Menu.Item>
                            {/* <Menu.Item key="8" onClick={onMenuClick} ><Link to={PATH.CONTENT}> <UnorderedListOutlined /><span>Nội dung Text</span></Link></Menu.Item> */}
                            <Menu.Item key="9" onClick={onMenuClick}><Link to={PATH.BANK}> <DollarCircleFilled /><span>Ngân hàng</span></Link></Menu.Item>
                        </SubMenu>

                        <Menu.Item key="10" onClick={onMenuClick}><Link to={PATH.SETTING}><SettingFilled /><span>Setting</span></Link></Menu.Item>
                        <Menu.Item key="11" onClick={logOut}><LogoutOutlined /><span>Logout</span></Menu.Item>
                    </Menu>
                </Sider>
                <Layout style={{marginBottom:'24px', marginInlineStart: collapsed ? (isMobile ? 0 : 50) : 200 }}>
                    <Header
                        style={{
                            padding: 0,
                            background: colorBgContainer,
                        }}
                    >
                        <Button
                            type="text"
                            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                            onClick={collapseMenu}
                            style={{
                                position: "sticky",
                                top: 0,
                                fontSize: '16px',
                                width: 64,
                                height: 64,
                            }}
                        />
                    </Header>
                    <Content
                        style={
                            currentPath === "/" ?
                                {
                                    margin: isMobile ?'4px':'16px',
                                    padding: isMobile ? "5px" : '20px', 
                                    paddingBottom:"48px",
                                    marginBottom:"48px",
                                    // minHeight: 280,
                                    // maxHeight: '98vh',
                                    overflow: 'initial', 
                                }
                                : {
                                    margin: '16px',
                                    padding: isMobile ? "5px" : '24px',
                                    paddingBottom:"48px",
                                    marginBottom:"48px",
                                    // minHeight: 280,
                                    // maxHeight: '98vh',
                                    // overflowY: 'scroll',
                                    background: colorBgContainer,
                                    borderRadius: borderRadiusLG,
                                    overflow: 'initial'
                                }}
                    >
                        {props.children}
                    </Content>
                </Layout>
            </Layout>
        </Layout>

    )
}